var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 30h-2a5 5 0 0 1 -5-5v-18a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5v18a1 1 0 0 1 -2 0v-18a3 3 0 0 0 -3-3h-6a3 3 0 0 0 -3 3v18a3 3 0 0 0 3 3h2a3 3 0 0 0 3-3v-16a1 1 0 0 0 -1-1h-2a1 1 0 0 0 -1 1v13a1 1 0 0 1 -1 1 1 1 0 0 1 -1-1v-13a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v16a5 5 0 0 1 -5 5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachment-icon.09e92b8bfd758feb6d98a5235818f834.svg";
export { ForwardRef as ReactComponent };